import AttendanceService from "@/views/attendance/services/attendance.service.js";

export default {
    namespaced: true,
    state: {
        S_WORKING_DAYS: [],
    },
    getters: {
        G_WORKING_DAYS: (state) => state.S_WORKING_DAYS,
    },
    mutations: {
        SET_WORKING_DAYS(state, payload) {
            state.S_WORKING_DAYS = payload;
        },
    },
    actions: {
        async A_PERSONAL_WORKING_DAYS({ commit }, payload) {
            try {
                const employeeId = JSON.parse(localStorage.getItem("userData")).employee_id;
                const { data } = await AttendanceService.getPersonalWorkingDays({ personal_id: employeeId });
                commit("SET_WORKING_DAYS", data[0]);
            } catch (error) {
                throw error;
            }
        },
    },
};
